import React, { FunctionComponent } from 'react';
import { ResponsiveImage } from 'components/elements';
import { WPAcfHeroSimple } from 'types/acf/hero';
import { Block } from 'components/elements';

interface OwnProps {
  data: WPAcfHeroSimple | null;
}

type HeroSimpleProps = JSX.IntrinsicElements['div'] & OwnProps;

const HeroSimple: FunctionComponent<HeroSimpleProps> = props => {
  const { data } = props;

  if (data) {
    const { desktopImage, mobileImage } = data;

    return (
      <Block id="hero-simple" width="full" data-module="hero-simple">
        <ResponsiveImage desktopImage={{ config: desktopImage }} mobileImage={{ config: mobileImage || desktopImage }} />
      </Block>
    );
  }
  return null;
};

export default HeroSimple;
